import React, { useState } from "react";
import clsx from "clsx";

import { Drawer, Box, AppBar, Toolbar, List, CssBaseline, useMediaQuery } from "@mui/material";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useDispatch } from "react-redux";

// Components
import { ResolutionsEnum } from "@/main/services/enum/ResolutionsEnum";
import DrawerMenuItemComponent from "./drawerMenuItemComponent";
import HeaderUserBoxComponent from "../../header/headerUserBox/headerUserBoxComponent";

// Redux
import { useUserReducer } from "@/main/store/user";
import { setOpenMenu, useMenuReducer } from "../../../store/menu";

// Models
import { MenuResponse } from "../../../models/response/menu";

// Styles
import { useStyles } from "./styles";
import * as S from "./styles";
import { useTheme } from "@mui/material/styles";
import { getCommonColors } from "@style/styleMaterialUIGlobal";
import { useVisualIdentityReducer } from "@/main/store/visualIdentity";

export default function DrawerMenuComponent(props: { data: MenuResponse[] }) {
	const classes = useStyles();
	const theme = useTheme();
	getCommonColors(theme);
	const menuReducer = useMenuReducer();
	const userReducer = useUserReducer();
	const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
	const textColor = theme.palette.getContrastText(visualIdentityReducer.colors?.headerColor);

	const dispatch = useDispatch();

	const isMobileMenu = useMediaQuery(`(max-width:${ResolutionsEnum.tablet}px)`);

	const [parentMenuSelected, setParentMenuSelected] = useState("");

	const handleDrawerOpen = () => {
		dispatch(setOpenMenu(true));
	};

	const handleDrawerClose = () => {
		dispatch(setOpenMenu(false));
	};

	function renderMenuItems() {
		return props.data.map((menu: MenuResponse) => {
			return (
				<DrawerMenuItemComponent
					key={menu.idModule}
					menu={menu}
					open={menuReducer.open}
					setParentMenuSelected={setParentMenuSelected}
					preOpenMenu={parentMenuSelected === menu.name}
					parentMenuSelected={parentMenuSelected}
				/>
			);
		});
	}

	function renderIconMenu() {
		return (
			<IconButton
				className="btn-action-drawer"
				style={{ marginRight: 10 }}
				onClick={!menuReducer.open ? handleDrawerOpen : handleDrawerClose}
			>
				{!menuReducer.open ? (
					<MenuIcon style={{ color: textColor, width: 18 }} />
				) : (
					<ChevronLeftIcon style={{ color: textColor, width: 18 }} />
				)}
			</IconButton>
		);
	}

	const drawerRootClassName = isMobileMenu
		? "drawer-menu"
		: `drawer-menu ${clsx(classes.drawer, {
				[classes.drawerOpen]: menuReducer.open,
				[classes.drawerClose]: !menuReducer.open,
			})}`;

	const drawerPaperClassName = isMobileMenu
		? classes.drawerOpen
		: clsx(
				{ borderRight: "none" },
				{
					[classes.drawerOpen]: menuReducer.open,
					[classes.drawerClose]: !menuReducer.open,
				},
			);

	const drawerRootStyle: React.CSSProperties = isMobileMenu
		? { zIndex: 1399 }
		: {
				width: "100%",
				zIndex: menuReducer.open ? 1399 : 1,
				position: "absolute",
			};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar position="fixed" className={classes.containerAppBar} style={{ zIndex: menuReducer.open ? 1400 : 2 }}>
				<Toolbar className="toolbar-drawer-menu">
					{renderIconMenu()}
					<S.AreaLogo>
						<img src={visualIdentityReducer.logoUrl} alt="" />
					</S.AreaLogo>
					<Box className="d-flex align-items-center" style={{ flexGrow: 1, justifyContent: "flex-end" }}>
						<Box className={classes.containerActions}>
							<HeaderUserBoxComponent
								user={{
									avatar: null,
									name: userReducer?.currentUser?.name || null,
									email: userReducer?.currentUser?.email || null,
								}}
								companyTradeName={userReducer?.currentUser?.companyTradeName || null}
								version={userReducer?.currentUser?.version || null}
							/>
						</Box>
					</Box>
				</Toolbar>
			</AppBar>

			<Drawer
				variant={isMobileMenu ? "temporary" : "permanent"}
				open={isMobileMenu ? menuReducer.open : undefined}
				ModalProps={{ keepMounted: true }}
				style={drawerRootStyle}
				className={drawerRootClassName}
				classes={{ paper: drawerPaperClassName }}
				onClose={handleDrawerClose}
			>
				<div className={classes.toolbar} />
				<List>{renderMenuItems()}</List>
			</Drawer>
		</div>
	);
}
